import type {
  NtpAdEvent,
  NtpNewsEvent,
  NtpSettingChanged,
} from '../../../composables/analytics/types'
import { getAugmentedProperties } from '../../../composables/analytics/helper'

export async function sendMixpanelEvent(
  name: 'query' | 'QueryNonMonetized_Submitted',
  data: {
    location: 'ntp'
    trigger: 'keyboard-return' | 'suggestion-press'
    monetized?: boolean
    active_search_provider?: string
  }
): Promise<void>
export async function sendMixpanelEvent(
  name: `NtpAd_${'Rendered' | 'Clicked'}`,
  data: NtpAdEvent
): Promise<void>
export async function sendMixpanelEvent(
  name:
    | 'NtpOriginalNewsButton_Clicked'
    | `NtpNewsTile_${'Clicked' | 'Rendered'}`,
  data: NtpNewsEvent
): Promise<void>
export async function sendMixpanelEvent(
  name: `NtpShortcutAd_${'Clicked' | 'Rendered'}`,
  data: NtpShortcutEvent
): Promise<void>
export async function sendMixpanelEvent(
  name: 'NtpSetting_Changed',
  data: NtpSettingChanged
): Promise<void>
export async function sendMixpanelEvent(
  name: 'NtpPage_Viewed' | 'NtpMoreNews_Loaded' | 'NtpWeather_Clicked',
  data?: never
): Promise<void>
export function sendMixpanelEvent(name: string, data: unknown): Promise<void> {
  const siteSettingsStore = useSiteSettingsStore()
  const { data: siteSettings } = storeToRefs(siteSettingsStore)

  void mixpanelEventWithData(
    name,
    data,
    siteSettings ? toRaw(siteSettings) : undefined
  )
  return Promise.resolve()
}

async function mixpanelEventWithData(
  name: string,
  data: unknown,
  siteSettings?: Ref<SiteSettings>
) {
  const augmentedProperties = await getAugmentedProperties(siteSettings, name)
  const eventData = {
    ...augmentedProperties,
    ...(data || {}),
  }

  if (import.meta.client) {
    window.mixpanelEventCallLog = window.mixpanelEventCallLog || []
    window.mixpanelEventCallLog.push({ name, eventData })
  }

  const { shift, chrome, onelaunch } = getHostApis()
  const shiftAPI = shift?.analytics?.track
  if (shiftAPI) {
    return shiftAPI(name, eventData)
  }

  const oneLaunchAPI = onelaunch?.sendEvent
  if (oneLaunchAPI) {
    oneLaunchAPI(name, eventData)
    return
  }

  const chromeAPI = chrome?.runtime?.sendEvent
  if (chromeAPI) {
    chromeAPI(name, eventData)
  }
}
